import React, { useState, useEffect } from 'react';
import './CookieConsent.scss';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const allConsent = {
      essential: true,
      analytics: true,
      preferences: true,
      marketing: true
    };
    saveConsent(allConsent);
  };

  const handleEssentialOnly = () => {
    const essentialConsent = {
      essential: true,
      analytics: false,
      preferences: false,
      marketing: false
    };
    saveConsent(essentialConsent);
  };

  const saveConsent = (consentPreferences) => {
    localStorage.setItem('cookie-consent', JSON.stringify({
      preferences: consentPreferences,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
    updateCookiePreferences(consentPreferences);
  };

  const updateCookiePreferences = (prefs) => {
    if (!prefs.analytics) {
      // Disable analytics cookies
      // window['ga-disable-UA-XXXXX-Y'] = true;
    }
    if (!prefs.marketing) {
      // Disable marketing cookies
    }
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <p>
          We use cookies to enhance your experience. Please select which cookies you'd like us to use.
          <a href="/privacy" className="privacy-link">Privacy Policy</a>
        </p>
        <div className="cookie-actions">
          <button onClick={handleEssentialOnly} className="btn-secondary">
            Essential Only
          </button>
          <button onClick={handleAcceptAll} className="btn-primary">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 